export const hm5LimitedReleaseDetailConstants = {
  HM5_LIMITED_RELEASE_DETAIL_LOADING: "HM5_LIMITED_RELEASE_DETAIL_LOADING",
  HM5_LIMITED_RELEASE_DETAIL_SUCCESS: "HM5_LIMITED_RELEASE_DETAIL_SUCCESS",
  HM5_LIMITED_RELEASE_DETAIL_FAILURE: "HM5_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const createHM5LimitedReleaseDetailConstants = {
  CREATE_HM5_LIMITED_RELEASE_DETAIL_LOADING:
    "CREATE_HM5_LIMITED_RELEASE_DETAIL_LOADING",
  CREATE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS:
    "CREATE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS",
  CREATE_HM5_LIMITED_RELEASE_DETAIL_FAILURE:
    "CREATE_HM5_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const editHM5LimitedReleaseDetailConstants = {
  EDIT_HM5_LIMITED_RELEASE_DETAIL_LOADING:
    "EDIT_HM5_LIMITED_RELEASE_DETAIL_LOADING",
  EDIT_HM5_LIMITED_RELEASE_DETAIL_SUCCESS:
    "EDIT_HM5_LIMITED_RELEASE_DETAIL_SUCCESS",
  EDIT_HM5_LIMITED_RELEASE_DETAIL_FAILURE:
    "EDIT_HM5_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const deleteHM5LimitedReleaseDetailConstants = {
  DELETE_HM5_LIMITED_RELEASE_DETAIL_LOADING:
    "DELETE_HM5_LIMITED_RELEASE_DETAIL_LOADING",
  DELETE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS:
    "DELETE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS",
  DELETE_HM5_LIMITED_RELEASE_DETAIL_FAILURE:
    "DELETE_HM5_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const addTargetHM5LimitedReleaseDetailConstants = {
  ADD_TARGET_HM5_LIMITED_RELEASE_DETAIL_LOADING:
    "ADD_TARGET_HM5_LIMITED_RELEASE_DETAIL_LOADING",
  ADD_TARGET_HM5_LIMITED_RELEASE_DETAIL_SUCCESS:
    "ADD_TARGET_HM5_LIMITED_RELEASE_DETAIL_SUCCESS",
  ADD_TARGET_HM5_LIMITED_RELEASE_DETAIL_FAILURE:
    "ADD_TARGET_HM5_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const removeTargetHM5LimitedReleaseDetailConstants = {
  REMOVE_TARGET_HM5_LIMITED_RELEASE_DETAIL_LOADING:
    "REMOVE_TARGET_HM5_LIMITED_RELEASE_DETAIL_LOADING",
  REMOVE_TARGET_HM5_LIMITED_RELEASE_DETAIL_SUCCESS:
    "REMOVE_TARGET_HM5_LIMITED_RELEASE_DETAIL_SUCCESS",
  REMOVE_TARGET_HM5_LIMITED_RELEASE_DETAIL_FAILURE:
    "REMOVE_TARGET_HM5_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const activateHM5LimitedReleaseDetailConstants = {
  ACTIVATE_HM5_LIMITED_RELEASE_DETAIL_LOADING:
    "ACTIVATE_HM5_LIMITED_RELEASE_DETAIL_LOADING",
  ACTIVATE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS:
    "ACTIVATE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS",
  ACTIVATE_HM5_LIMITED_RELEASE_DETAIL_FAILURE:
    "ACTIVATE_HM5_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const deactivateHM5LimitedReleaseDetailConstants = {
  DEACTIVATE_HM5_LIMITED_RELEASE_DETAIL_LOADING:
    "DEACTIVATE_HM5_LIMITED_RELEASE_DETAIL_LOADING",
  DEACTIVATE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS:
    "DEACTIVATE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS",
  DEACTIVATE_HM5_LIMITED_RELEASE_DETAIL_FAILURE:
    "DEACTIVATE_HM5_LIMITED_RELEASE_DETAIL_FAILURE",
};
